import { object, string, boolean } from 'yup';
const PropertyInformation = object({
  futureTitleOwner: string().required('Please provide who the title will be held by'),
  titleMannerHeld: string().required('Please select the manner in which the title will be held'),
  indianCountryLandTenure: boolean().required('Please select an option'),
  indianCountryLandTenureType: string().nullable().when('indianCountryLandTenure', {
    is: value => !!value,
    then: schema => schema.required('Please select an Indian Country Land Tenure value')
  }),
  propertyPartOfTrust: boolean().required('Please select an option'),
  trustDetails: string().nullable().when('propertyPartOfTrust', {
    is: value => !!value,
    then: schema => schema.required('Please select trust information')
  })
});
export default PropertyInformation;
//# sourceMappingURL=index.js.map